import { I18nextProvider } from "react-i18next";
import { ToastContainer } from "react-toastify";
import { RecurlyProvider, Elements } from '@recurly/react-recurly';
import i18next from "./i18next/i18next";
import Router from "./router/Router";

function App() {
  return (
    <RecurlyProvider publicKey="ewr1-5oFEJbtYWURbdeA3z2DHmJ">
      <Elements>
        <div className="full-section">
          <I18nextProvider i18n={i18next}>
            <ToastContainer />
            <Router />
          </I18nextProvider>
        </div>
      </Elements>
    </RecurlyProvider>
  );
}

export default App;
